<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Deduction or Earning"
      text="Update DOE"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                label="Deduction or Earning"
                :value="doe.deduction_or_earning.name"
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localDoe.amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
                @keydown.native="preventNegativeKey"
                @paste.native="preventNegativePaste"
              />
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update and re-compute
        </v-btn>
      </v-card-actions> 
    </material-card>   
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      doe: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localDoe: null,
        loading: false,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.localDoe = { ...this.doe }

        if (this.localDoe.amount) { this.localDoe.amount = Math.abs(Math.round((this.localDoe.amount / 100) * 100) / 100).toFixed(2) }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.computationDoes().update(this.doe.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      preventNegativeKey (event) {
        if (event.key === '-' || event.key === 'Subtract') event.preventDefault()
      },
      preventNegativePaste (event) {
        if (event.clipboardData.getData('text').indexOf('-') !== -1) event.preventDefault()
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          amount: this.localDoe.amount.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>
